<template>
  <div
    ref="welcome"
    class="welcome full-screen"
    :style="{ backgroundImage: `url('${src}')` }"
    :data-is-hide="!isShowingWelcome"
  >
    <span class="count">{{ count }}</span>
    <button class="skip" v-on:click="hideWelcome">{{$t("welcome.into")}}</button>
  </div>
</template>

<script>
  import { show, hide } from '@/assets/js/methods/fullscreen.js';

  let countDownTime;

  export default {
    data: () => ({
      isShowingWelcome: true,
      count: 6,
    }),
    props: {
      src: String,
    },
    methods: {
      showWelcome() {
        //console.log("src is %s",this.src);
        this.isShowingWelcome = true;
        show(this.$refs.welcome);
      },
      hideWelcome() {
        clearInterval(countDownTime);
        hide(this.$refs.welcome);
        this.isShowingWelcome = false;
      },
      startCountDown() {
        //console.log("start to count down");
        if (this.count > 1) {
          this.count -= 1;
          countDownTime = setTimeout(this.startCountDown, 1000);
        } else {
          this.hideWelcome();
        }
      },
    },
    mounted() {
      this.startCountDown();
      //console.log("show welcome");
      this.showWelcome();
    },
  }
</script>

<style lang="sass" scoped>
  .welcome
    background-repeat: no-repeat
    background-position: center
    background-size: cover
    z-index: 9
  .skip
    width: 100%
    height: 2.8rem
    background: rgba(0, 0, 0, .8)
    border: none
    color: #fff
    font-size: 1.3rem
    position: absolute
    bottom: 0
    left: 0
  .count
    display: inline-block
    position: absolute
    right: 1.2rem
    top: 1.2rem
    padding: 0 1.3rem
    line-height: 2rem
    background: rgba(0,0,0,.5)
    border-radius: 10rem
    width: initial
    font-size: 1.3rem
    color: #fff
    &::after
      content: 's'
</style>
